import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiFormLogicConditionIfIsContainerComponent } from './fi-form-logic-condition-editor-dialog/fi-form-logic-condition-if-is-container/fi-form-logic-condition-if-is-container.component';
import { FiFormLogicConditionIfIsPredicateComponent } from './fi-form-logic-condition-editor-dialog/fi-form-logic-condition-if-is-predicate/fi-form-logic-condition-if-is-predicate.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiFormConditionHelperService } from '@fi-shared/fi-form-shared/fi-form-condition-helper.service';
import { MatDividerModule } from '@angular/material/divider';
import { FiFormLogicConditionListItemComponent } from './fi-form-logic-condition-list-item/fi-form-logic-condition-list-item.component';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiFormLogicConditionEditorDialogComponent } from './fi-form-logic-condition-editor-dialog/fi-form-logic-condition-editor-dialog.component';
import { FiFormLogicConditionOperatorMenuComponent } from './fi-form-logic-condition-editor-dialog/fi-form-logic-condition-operator-menu/fi-form-logic-condition-operator-menu.component';
import { FiFormLogicConditionActionsComponent } from './fi-form-logic-condition-editor-dialog/fi-form-logic-condition-actions/fi-form-logic-condition-actions.component';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        MatFormFieldModule,
        MatSelectModule,
        FiErrorMessageModule,
        FormsModule,
        MatMenuModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        FiIconTooltipButtonModule,
    ],
    declarations: [
        FiFormLogicConditionIfIsContainerComponent,
        FiFormLogicConditionIfIsPredicateComponent,
        FiFormLogicConditionListItemComponent,
        FiFormLogicConditionEditorDialogComponent,
        FiFormLogicConditionOperatorMenuComponent,
        FiFormLogicConditionActionsComponent,
    ],
    providers: [FiFormConditionHelperService],
    exports: [FiFormLogicConditionListItemComponent],
})
export class FiFormEditLogicModule {}
